import { render, staticRenderFns } from "./prescriptiondetail.vue?vue&type=template&id=c62f8256&scoped=true&"
import script from "./prescriptiondetail.vue?vue&type=script&lang=js&"
export * from "./prescriptiondetail.vue?vue&type=script&lang=js&"
import style0 from "./prescriptiondetail.vue?vue&type=style&index=0&id=c62f8256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f8256",
  null
  
)

export default component.exports